<template>
  <form>
    <div class="dashboard-block">
      <h2>Commission</h2>

      <div class="panel panel-grey">
        <div class="panel-body">
          <div class="row row-clear-md-4">
            <div class="col-xs-12 col-md-4">
              <div :class="$hasErrorClass($v.stateCommissionRate, 'form-group')">
                <label class="control-label">{{ clientName }} Commission</label>
                <div class="input-group">
                  <input
                    name="commission_rate"
                    type="number"
                    class="form-control"
                    v-model="$v.stateCommissionRate.$model">
                  <span class="input-group-addon"><i class="fa fa-percent"></i></span>
                </div>

                <vuelidate-help label="Commission rate" :field="$v.stateCommissionRate"/>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <ladda-button
            type="submit"
            class="btn btn-sm btn-primary"
            :click="handleSaveChangesCallback">
            Save Changes
          </ladda-button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import { stateMapper } from 'mixins/users'
import { between, numeric } from 'vuelidate/lib/validators'
import { notify } from 'utils'
import VuelidateHelp from '../misc/VuelidateHelp'

export default {
  mixins: [stateMapper],

  components: { VuelidateHelp },

  validations: {
    stateCommissionRate: {
      numeric,
      between: between(0, 100)
    }
  },

  methods: {
    ...mapActions('user', ['updateUser']),

    handleSaveChangesCallback () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.resolve()
      }
      const payload = {
        commission_rate: this.user.commission_rate
      }

      return this.updateUser({ id: this.user.id, payload })
    }
  }
}
</script>
